import React from 'react'
import PropTypes from 'prop-types'
import ClearFilters from '../ClearFilters/ClearFilters'
import ApplyFilters from '../ApplyFilters/ApplyFilters'

const SubmitClearFilters = props => {

    const { criteriaToApply, handleClose } = props

    return (
        <>
            <div className="flex justify-end px-6 py-4 space-x-4 mt-auto items-center">
                <div>
                    <ClearFilters criteriaToApply={criteriaToApply} classes="btn btn-sm"></ClearFilters>
                </div>
                <div>
                    <ApplyFilters criteriaToApply={criteriaToApply} handleClose={handleClose}></ApplyFilters>
                </div>
            </div>
        </>
    )
}

export default SubmitClearFilters

SubmitClearFilters.propTypes = {
    criteriaToApply: PropTypes.string,
    handleClose: PropTypes.any
}
